import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import DonarNav from 'components/donar-details/DonorNav';
import DonorProfile from './DonorProfile';
import DonorGiving from './DonorGiving';
import DonorGivingDetails from './DonorGivingDetails';
import DonorSponsorships from './DonorSponsorships';
import DonorCommunications from './DonorCommunications';
import DonorRelationManagement from './DonorRelationManagement';
import DonorGiftAid from './DonorGiftAid';
import DonorFeedback from './DonorFeedback';

const DonorLayout = () => {
  return (
    <div className="py-0">
      <Row className="g-3">
        <Col lg={3}>
          <DonarNav />
        </Col>
        <Col lg={9}>
          <Routes>
            <Route path="profile" element={<DonorProfile />} />
            <Route path="giving" element={<DonorGiving />} />
            <Route path="giving/:giving_id" element={<DonorGivingDetails />} />
            <Route path="sponsorships" element={<DonorSponsorships />} />
            <Route path="communications" element={<DonorCommunications />} />
            <Route
              path="relation_management"
              element={<DonorRelationManagement />}
            />
            <Route path="gift_aid" element={<DonorGiftAid />} />
            <Route path="feedback" element={<DonorFeedback />} />

            <Route path="*" element={<Navigate to="profile" replace />} />
          </Routes>
        </Col>
      </Row>
    </div>
  );
};

export default DonorLayout;
